module.exports = __webpack_public_path__ + "img/Weapon_131.42c607bd.png";